import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { IIBServiceClient } from '@api/IIBServiceClient'

// To access window property applicationEventListener
declare global {
    // tslint:disable-next-line
    interface Window {
        applicationEventListener: any
    }
}

export const ActivityHeartbeatServiceConstants = Object.freeze({
    // We will retain the last 2 heart beats to account for the race condition that the heartbeat happens right around the time of a resume event
    HEART_BEATS_TO_KEEP: 2,
    // 3s
    HEART_BEAT_INTERVAL: 3 * 1000,
    // 15.25s
    HEART_BEAT_ACCEPTED_RANGE: 15.25 * 1000,
})

const _lastHeartBeats: number[] = []

export const init = () => {
    if (!EnvironmentDetail.isAndroid()) {
        console.info('ATBase: This is not an Android device. We are not initializing the ActivityHeartBeatService')
        return
    }

    for (let x = 0; x < ActivityHeartbeatServiceConstants.HEART_BEATS_TO_KEEP; x++) {
        _lastHeartBeats.push(0)
    }
    for (let x = 0; x < ActivityHeartbeatServiceConstants.HEART_BEATS_TO_KEEP; x++) {
        addHeartBeat()
    }

    const _interval = setInterval(addHeartBeat, ActivityHeartbeatServiceConstants.HEART_BEAT_INTERVAL)

    // Subscribe to resume listener
    if (window.applicationEventListener) {
        console.info('ATBase: applicationEventListener found')
        window.applicationEventListener.addEventListener('onleavingbackground', handleResumeSignal, false)
    } else {
        console.error('ATBase: applicationEventListener not found')
    }
}

const addHeartBeat = () => {
    _lastHeartBeats.shift()
    _lastHeartBeats.push(Date.now())
}

const shouldLogout = () => {
    const currentTime = Date.now()

    console.info('ATBase: shouldLogout called, currentTime: ' + currentTime + '; heartbeats: ' + JSON.stringify(_lastHeartBeats))

    // Check if any elements of lastHeartBeats are greater than the range
    return _lastHeartBeats.some((date) => {
        return Math.abs(currentTime - date) > ActivityHeartbeatServiceConstants.HEART_BEAT_ACCEPTED_RANGE
    })
}

const handleResumeSignal = () => {
    console.info('ATBase: Resume Signal received')

    // Resume Signal has been received. Checking heartbeats to see if we need to log out
    if (shouldLogout()) {
        if (EnvironmentDetail.isIIBAuthN()) {
            IIBServiceClient.logout()
        } else {
            console.info('ATBase: Should Logout is true, logging out')
            window.location.hash = '/logout?keep_username=false'
        }

    } else {
        console.info('ATBase: Should Logout is false')
    }
}
